import { CLIENT_MESSAGES } from '../core/protocol.ts';
import type { SdkClient } from '../core/client.ts';

export interface LoadingModule {
  progress(fraction: number): void;
  ready(): void;
  failed(message?: string): void;
}

/**
 * The only channel that works before a session exists: the host draws its
 * loading state from these, so a game that never reports appears to hang until
 * the wrapper's grace timer gives up.
 */
export function createLoadingModule(client: SdkClient): LoadingModule {
  return {
    progress(fraction) {
      const value = Number(fraction);
      if (!Number.isFinite(value)) return;
      client.notifyHost(CLIENT_MESSAGES.embedProgress, { progress: Math.max(0, Math.min(1, value)) });
    },

    ready() {
      client.notifyHost(CLIENT_MESSAGES.embedReady, {});
    },

    failed(message) {
      client.notifyHost(CLIENT_MESSAGES.embedError, {
        message: String(message ?? 'The game could not start.').slice(0, 200),
      });
    },
  };
}
